import React from 'react';
import { N20 } from '@atlaskit/adf-schema';
import Select from '@atlaskit/select';
import { DisplayMode } from '../../RenderForm';
import { ViewWrapper } from '../common/questionWrappers';
import { ViewOtherOption } from './ViewOtherOption';
const styles = {
  control: base => ({
    ...base,
    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${N20})`,
    borderColor: "var(--ds-border-disabled, #DFE1E6)",
    color: "var(--ds-text, #172B4D !important)"
  }),
  menu: base => ({
    ...base,
    color: "var(--ds-text, #172B4D)"
  })
};
export const ViewDropdown = ({
  id,
  value,
  options,
  hasOtherOption,
  otherOptionText,
  displayMode
}) => {
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    // This is a Disabled Select
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, {
      key: id,
      id: id,
      options: options,
      value: value,
      placeholder: "",
      isDisabled: true,
      styles: styles
    }), /*#__PURE__*/React.createElement(ViewOtherOption, {
      dropdown: true,
      display: hasOtherOption,
      value: otherOptionText
    }));
  }
  // if the user has selected 'Other...' and provided a value we display that value. Otherwise we display 'Other...'
  return /*#__PURE__*/React.createElement(ViewWrapper, null, hasOtherOption && otherOptionText || value && value.label);
};